import { Col, Container, Row } from "react-bootstrap"
import { navigateTo } from "../../redux/router/routerActions"
import { useAppDispatch } from "../../redux/store"
import QuickForm from "../../Components/Forms/QuickForm/QuickForm"
import { convertActiveQueryToUrl } from "../../Helpers/Query/queryHelpers";
import useActiveQueryHook from "../../Hooks/UseActiveQuery/useActiveQueryHook";
import BookingGuestEntry from "../../Components/BookingGuests/BookingGuestEntry/BookingGuestEntry"
import useMyProperties from "../../Hooks/UseMyProperties/UseMyPropertiesHook"
import useMyPropertiesSelectValues from "../../Hooks/UseMyProperties/UseMyPropertySelectValuesHook"
import { useGetBookingGuestsQuery } from "../../services/bClientApi"
import MongoPagination from "../../Components/Pagination/MongoPagination"

export default function BookingGuestsPage() {

    const { myProperties, publicPropertyIdKeys } = useMyProperties()
    const propertyOptions = useMyPropertiesSelectValues(myProperties)

    const dispatch = useAppDispatch()

    const { activeQuery } = useActiveQueryHook({
        query: {},
        page: 1,
        limit: 10,
    })

    const {
        data,
        isLoading,
        isFetching,
        error,
    } = useGetBookingGuestsQuery({
        bookingGuestsQuery: {
            propertyId: publicPropertyIdKeys,
            ...activeQuery.query,
        },
        pagination: {
            page: activeQuery.page,
            limit: activeQuery.limit,
        }
    }, { skip: publicPropertyIdKeys.length === 0 })

    const bookingGuestsList = data?.docs || []

    const loadPage = (pageParams: { query: any, page: number, limit: number }) => {
        console.log('loadPage', pageParams)
        const destination = `/booking-guests?${convertActiveQueryToUrl(pageParams)}`
        dispatch(navigateTo(destination))
    }


    return (
        <Container>
            <Row>
                <Col>
                    <h1>BookingGuests</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    <QuickForm
                        initialData={{
                            // name: activeQuery.query.name,
                            propertyId: activeQuery.query.propertyId,
                            arrivalTimeStart: activeQuery.query.arrivalTimeStart,
                            arrivalTimeEnd: activeQuery.query.arrivalTimeEnd,
                        }}
                        fields={[
                            {
                                fieldName: 'propertyId',
                                fieldLabel: 'Property',
                                fieldType: 'select',
                                placeholder: '- Select Property -',
                                options: propertyOptions,
                            },
                            {
                                fieldName: 'arrivalTimeStart',
                                fieldLabel: 'Arrival Start',
                                fieldType: 'date',
                                placeholder: 'Arrival Start',
                                layout: {
                                    xs: 12,
                                    sm: 6,
                                }
                            },
                            {
                                fieldName: 'arrivalTimeEnd',
                                fieldLabel: 'Arrival End',
                                fieldType: 'date',
                                placeholder: 'Arrival End',
                                layout: {
                                    xs: 12,
                                    sm: 6,
                                }
                            },
                            {
                                fieldName: 'firstName',
                                fieldLabel: 'Name',
                                fieldType: 'text',
                                placeholder: 'Name',
                                layout: {
                                    xs: 12,
                                    sm: 6,
                                }
                            },
                            {
                                fieldName: 'lastName',
                                fieldLabel: 'Last Name',
                                fieldType: 'text',
                                placeholder: 'Last Name',
                                layout: {
                                    xs: 12,
                                    sm: 6,
                                }
                            },
                            {
                                fieldName: 'phone',
                                fieldLabel: 'Phone',
                                fieldType: 'text',
                                placeholder: 'Phone',
                                layout: {
                                    xs: 12,
                                    sm: 6,
                                }
                            },
                            {
                                fieldName: 'email',
                                fieldLabel: 'Email',
                                fieldType: 'text',
                                placeholder: 'Email',
                                layout: {
                                    xs: 12,
                                    sm: 6,
                                }
                            },
                        ]}
                        disabled={isLoading || isFetching}
                        onSubmit={(values: any) => {
                            const searchValues = { ...values }
                            if (searchValues.phone) {
                                // remove all non-numeric characters from phone
                                searchValues.phone = searchValues.phone.replace(/\D/g, '');
                            }
                            loadPage({
                                // query: values,
                                query: searchValues,
                                page: 1,
                                limit: activeQuery.limit
                            })
                        }}
                    />

                    <div className="bookingGuest-list-container">
                        {bookingGuestsList && bookingGuestsList.length > 0 && bookingGuestsList.map((bookingGuestEntry: any, idx: number) => (
                            <BookingGuestEntry
                                key={idx}
                                bookingGuestInfo={bookingGuestEntry}
                                propertyData={myProperties[bookingGuestEntry.propertyId] ? myProperties[bookingGuestEntry.propertyId] : undefined}
                            />
                        ))
                        }
                    </div>

                    <MongoPagination
                        data={data}
                        loadPage={(pageLoadInfo: { page: number, limit?: number }) => {
                            loadPage({
                                ...activeQuery,
                                ...pageLoadInfo
                            })
                        }}
                    />
                </Col>
            </Row>
        </Container>
    )
}
